// extracted by mini-css-extract-plugin
export default {"title":"ClientList_title__KfGuJ","content":"ClientList_content__ao9XE"};